// TODO: Import React module
import * as React from 'react';

// TODO: Import MUI module
import { Box, Button, Typography, } from '@mui/material';

// TODO: Import MUI icon
import { PictureAsPdf } from '@mui/icons-material';

// TODO: Import context
//import { Context } from '../Common/Context';

// TODO: Import custom component
import BoxSubPage from '../Common/BoxSubPage';

const P202505191128 = () => {
    if (window.location.href.startsWith('http://localhost')) console.log('Component P202505191128 Rendered');

    // TODO: Define useContext
    //const context = React.useContext(Context);

    // TODO: Define reference

    // TODO: Define variable

    // TODO: Define event
    const downloadPdf = () => {
        const pdfUrl = "https://www.pohtyh.edu.hk/Files/Pages/P202505191128/QSIP Newsletter_18_ebook.pdf#page=07"; // 請替換成你的 PDF URL
        const link = document.createElement("a");
        link.href = pdfUrl;
        link.setAttribute("download", "QSIP Newsletter_18_ebook.pdf"); // 可選：設置下載的檔案名稱
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    };

    // TODO: Return component

    return (
        <BoxSubPage
            disableMenu={true}
            disableSubtitle={true}
            id="P202505191128"
            title="學校專訪：「浮才、育才、揚才」的課程特色"
        >
            <Typography variant="body1">本校獲得QSIP第十八期通訊（03/2025）邀請訪問，介紹本校以「浮才、育才、揚才」作理念的「愉快星期五」（Happy Friday）特色課程。該課程旨在通過多元化的聯課活動（如瑜珈、咖啡拉花、語言班等）啟發學生的潛能，並結合校園設施（如健身室、Band房）營造支持性環境。學校還通過認可制度（如頒發獎項、優化成績表）表揚學生的多元成就，幫助他們建立自信並突破社會階層的限制，體現了全人教育的理念。</Typography>
            <Box sx={{my:2}}>
                <Button color="primary" onClick={downloadPdf} startIcon={ <PictureAsPdf />} variant="contained">
                    按此下載 PDF
                </Button>
            </Box>
            <iframe
                src="https://www.pohtyh.edu.hk/Files/Pages/P202505191128/QSIP Newsletter_18_ebook.pdf#page=07"
                style={{ height: '80vh' }}
                title="學校專訪：「浮才、育才、揚才」的課程特色"
            >
            </iframe>
        </BoxSubPage>
    );
}

export default P202505191128;